import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import PageMenu from "../../menus/PageMenu";

export default function ConsultingMenu(){

    const [menuData, setMenuData]=useState();

	//Fetch all consultancies
	const { isPending, isError, data, error }=useQuery(
        ['consultancies'], //Query key
        ()=>axios({ //Query function
            method:'get',
            url:WP_API_Settings.endpoint+'wp/v2/theme_consulting?orderby=menu_order&order=asc'
        })
    );

	useEffect(()=>{
		if(data?.data){
            let items=[];
            //Add each consultancy to the menu
            data.data.forEach((item)=>{
                //console.log(item)
                items.push(
                    {
                        url:'/services/consulting/'+item.slug,
                        title:item.title.rendered,
                    },
                );
            });
            setMenuData(items);
		}
	},[data]);

	//console.log(menuData)
    
    return(
        <PageMenu
            items={menuData}
            loading={!menuData}
        />
    );
}